export default "__VITE_ASSET__CjtVMIV8__$_?height=200&width=300__"